import React from 'react';
import { sidebarRoleManagement } from '../utils/UserManagement';
import Dashboard from './MainPage/Dashboard';
import MenuCards from './MainPage/MenuCards';

export default function MainPage() {


    if (sidebarRoleManagement(["anasayfa_dashboard_read"])) {
        return <Dashboard />;
    } else {
        return <MenuCards />;
    }
}
